// The signed message is six lines joined by \n: timestamp, upper-case method, path
// without the query string, raw query string, lower-case Content-Type, raw body.

async function hmacHex(secret, message) {
    const enc = new TextEncoder();
    const key = await crypto.subtle.importKey(
        'raw',
        enc.encode(secret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign'],
    );
    const sig = await crypto.subtle.sign('HMAC', key, enc.encode(message));

    return Array.from(new Uint8Array(sig))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

export async function signedRequest({ baseUrl, token, secret, method, path, rawBody }) {
    const body = rawBody || '';
    const [pathname, query = ''] = path.split('?');
    const contentType = body === '' ? '' : 'application/json';
    const timestamp = Math.floor(Date.now() / 1000);
    const canonical = [
        String(timestamp),
        method.toUpperCase(),
        pathname,
        query,
        contentType,
        body,
    ].join('\n');
    const signature = await hmacHex(secret, canonical);

    const headers = {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Timestamp': String(timestamp),
        'X-Signature': `sha256=${signature}`,
    };

    if (contentType !== '') {
        headers['Content-Type'] = contentType;
    }

    const res = await fetch(baseUrl.replace(/\/$/, '') + path, {
        method: method.toUpperCase(),
        headers,
        body: body === '' ? undefined : body,
    });

    const text = await res.text();
    let parsed = text;
    try {
        parsed = JSON.stringify(JSON.parse(text), null, 2);
    } catch (e) {
        // nem JSON, nyersen marad
    }

    return { status: res.status, statusText: res.statusText, body: parsed };
}
